<template>
    <el-menu
            :default-active="$route.path"
            :collapse="collapse"
            :router="true"
    >
        <sidebar-item v-for="menu in menuList" :key="menu.id" :item="menu" :collapse="collapse"/>
    </el-menu>
</template>

<script>
  import SidebarItem from './SidebarItem'

  export default {
    name: 'Sidebar',
    components: {SidebarItem},
    props: {
      menuList: {
        type: Array,
        required: true
      },
      // 是否水平折叠收起菜单
      collapse: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
    .el-menu {
        border-right-width:0 !important;
    }
</style>
